module.exports = __webpack_public_path__ + "img/workHours.0654b371.svg";